<div class="flex h-full flex-col">
    <!-- header -->
    <div class="relative flex h-16 flex-none items-center justify-center px-4">
        <h1 class="text-base font-bold">
            {{ notificationTitleKey[selectedNotification] | translate }}
        </h1>
        <ion-button
            class="absolute right-0 top-1.5"
            [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
            (click)="cancel()"
            fill="clear">
            <ion-icon
                class="mr-1 text-xl dark:filter-yellow"
                [src]="(assetsPath$ | async) + '/img/close.svg'"></ion-icon>
        </ion-button>
    </div>

    <!-- content -->
    <div class="flex-1 space-y-4 overflow-y-auto px-4">
        <ion-list mode="ios" lines="full">
            <ng-container
                *ngIf="
                    stopsRoutesData?.stops?.length &&
                    (selectedNotification === 'stops' || selectedNotification === 'search')
                ">
                <ion-item *ngFor="let stop of stopsRoutesData.stops">
                    <ion-label class="py-2">
                        <div class="flex items-center gap-2">
                            <ion-icon
                                class="hu-light:text-black h-[1.6rem] w-[1.6rem] rounded text-white dark:filter-yellow"
                                [src]="(assetsPath$ | async) + '/img/explore/bus.svg'"
                                [attr.aria-label]="'STOP' | translate">
                            </ion-icon>
                            <div>
                                {{ stop.name }}
                                <div class="text-xs font-medium leading-4 text-grey-zambezy dark:text-contrast-yellow">
                                    {{ stop.desc }}
                                </div>
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
            </ng-container>

            <ng-container
                *ngIf="
                    stopsRoutesData?.routes?.length &&
                    (selectedNotification === 'routes' || selectedNotification === 'search')
                ">
                <ion-item *ngFor="let route of stopsRoutesData.routes">
                    <ion-label class="py-1">
                        <div class="flex items-center gap-2">
                            <rwidget-route-short-name
                                [label]="route.shortName"
                                [color]="route.icon?.color || 'var(--color-secondary)'"
                                [shape]="route.icon?.shape || ShapeType.ROUNDED"
                                size="md"></rwidget-route-short-name>
                            {{ route.longName }}
                        </div>
                    </ion-label>
                </ion-item>
            </ng-container>
        </ion-list>
    </div>

    <!-- footer -->
    <div class="flex-none bg-white p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] dark:bg-contrast-black">
        <button
            class="h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
            (click)="saveSubscription()"
            type="button">
            {{ 'SUBSCRIBE_TO_NOTIFICATIONS_BTN' | translate }}
        </button>
    </div>
</div>
